import React from 'react';
import styled from 'styled-components';
import { Typo } from 'tmt-ui-kit';
import xss from 'xss';

const Title = styled(Typo.HeaderTwo)`
  margin: 16px 0px 40px;
  text-transform: capitalize;
`;

const Content = styled.div`
  position: relative;
  padding-bottom: 12px;
  display: flex;
`;

const TextContainer = styled.div``;

const Time = styled(Typo.HeaderThree)`
  margin-top: -3px;
  margin-bottom: 6px;
  color: ${props => props.theme.orange} !important;
`;

const Text = styled(Typo.Paragraph)`
  font-size: 15px !important;
`;

const DotContainer = styled.div`
  position: relative;
  background: pink;
  margin-right: 24px;
  height: 100%;
`;

const Dot = styled.div`
  z-index: 1;
  position: absolute;
  border-radius: 22px;
  width: 12px;
  height: 12px;
  left: 0px;
  background: ${props => props.theme.orange};
  border: 2px solid ${props => props.theme.white};
`;

const Line = styled.div`
  position: absolute;
  height: 100%;
  left: 5px;
  border: 1px solid ${props => props.theme.orange};
`;

const PinContainr = styled.div`
  position: relative;
  &:after {
    content: '';
    position: absolute;
    top: -20px;
    left: 5px;
    width: 2px;
    height: 20px;
    background: ${props => props.theme.orange};
  }
`;

const Pin = styled.svg`
  position: absolute;
  top: -30px;
  left: -4px;
  width: 20px;
`;

const PinIcon = () => (
  <PinContainr>
    <Pin xmlns="http://www.w3.org/2000/svg" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 54.757 54.757">
      <g>
        <path d="M40.94,5.617C37.318,1.995,32.502,0,27.38,0c-5.123,0-9.938,1.995-13.56,5.617c-6.703,6.702-7.536,19.312-1.804,26.952  L27.38,54.757L42.721,32.6C48.476,24.929,47.643,12.319,40.94,5.617z M27.557,26c-3.859,0-7-3.141-7-7s3.141-7,7-7s7,3.141,7,7  S31.416,26,27.557,26z" data-original="#000000" className="active-path" data-old_color="#000000" fill="#E86A1A"/>
      </g>
    </Pin>
  </PinContainr>
);

const Itinerary = ({ data }) => {
  return (
    <div>
      <Title>Itinerary</Title>
      {data.map((d, i) => {
        return (
          <Content>
            {i === 0 && <PinIcon />}
            {(data.length - 1) !== i && <Line />}
            <DotContainer>{d.time && <Dot />}</DotContainer>
            <TextContainer>
              <Time>{d.time}</Time>
              <Text>
                {d.text.split('\n').map((line, index) => {
                  if (index + 1 < d.text.split('\n').length) {
                    return [
                      <span
                        key={`text-${index}`}
                        dangerouslySetInnerHTML={{
                          __html: xss(line),
                        }}
                      />,
                      <br key={`break-${index}`} />,
                    ];
                  }
                  return (
                    <span
                      key={`text-${index}`}
                      dangerouslySetInnerHTML={{
                        __html: xss(line),
                      }}
                    />
                  );
                })}
              </Text>
            </TextContainer>
          </Content>
        );
      })}
    </div>
  );
};

export default Itinerary;
